import { baseAxios } from "../../../../services/api";
import { setTableLoading } from "../loading/actions";
import {
  SET_ACCOUNT_MANAGERS,
  SET_CONFIRMATION_CALL_LIST,
  SET_CONFIRMATION_CALL_LIST_META,
  SET_CONFIRMATION_CALL_STATISTICS,
  SET_BRANCHES,
  SET_NOT_COMPLETED_CONFIRMATION_CALLS,
} from "./types";
import { api } from "../../../../configs/index";

export const setConfirmationCallList = (payload) => (dispatch) =>
  dispatch({ type: SET_CONFIRMATION_CALL_LIST, payload });
export const setAccountManagers = (payload) => (dispatch) =>
  dispatch({ type: SET_ACCOUNT_MANAGERS, payload });
export const setConfirmationCallListMeta = (payload) => (dispatch) =>
  dispatch({
    type: SET_CONFIRMATION_CALL_LIST_META,
    payload,
  });
export const setConfirmationCallStatistics = (payload) => (dispatch) =>
  dispatch({
    type: SET_CONFIRMATION_CALL_STATISTICS,
    payload: {
      completed: payload.completed_confirmation_calls_count,
      notCompleted: payload.not_completed_confirmation_calls_count,
    },
  });
export const setBranches = (payload) => (dispatch) =>
  dispatch({ type: SET_BRANCHES, payload });
export const setNotCompletedConfirmationCalls = (payload) => (dispatch) =>
  dispatch({ type: SET_NOT_COMPLETED_CONFIRMATION_CALLS, payload });

export const getConfirmationCallList =
  ({
    paginationParams = {
      per_page: 25,
      page: 1,
      order: "desc",
    },
    filterParams = {},
  }) =>
  async (dispatch) => {
    dispatch(setTableLoading(true));

    try {
      const { data } = await baseAxios().get(api.leads.confirmationCalls, {
        params: { ...filterParams, ...paginationParams },
      });

      // Check if we're filtering for unconfirmed calls only
      if (filterParams.show_unconfirmed_only) {
        // Use the specific unconfirmed calls data and metadata
        dispatch(
          setConfirmationCallList(data.not_completed_confirmation_calls || [])
        );
        dispatch(
          setConfirmationCallListMeta(
            data.not_completed_confirmation_calls_meta || {}
          )
        );
      } else {
        // Use the regular data structure
        dispatch(setConfirmationCallList(data.items));
        dispatch(setConfirmationCallListMeta(data.meta));
      }

      // Transform account_managers object to array format expected by frontend
      const transformedAccountManagers = data.account_managers
        ? Object.entries(data.account_managers).map(([name, id]) => ({
            id: id,
            name: name,
          }))
        : [];
      dispatch(setAccountManagers(transformedAccountManagers));
      const fallbackBranches = ["NY Market", "CA", "SF", "PA", "FL", "IL"];
      dispatch(
        setBranches(
          data.branches && data.branches.length
            ? data.branches
            : fallbackBranches
        )
      );
      dispatch(setConfirmationCallStatistics(data));
      // Store the uncompleted calls data for highlighting
      dispatch(
        setNotCompletedConfirmationCalls(
          data.not_completed_confirmation_calls || []
        )
      );
    } catch (e) {
      console.error(e);
    } finally {
      dispatch(setTableLoading(false));
    }
  };
